export const GAMER_ZONE_SEQUENCE = [
  "ArrowUp",
  "ArrowUp",
  "ArrowDown",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight",
  "ArrowLeft",
  "ArrowRight",
  "b",
  "a",
  "Enter",
] as const;

export type SequenceState = {
  index: number;
  unlocked: boolean;
};

export function normalizeKey(key: string): string {
  if (key === " " || key === "Spacebar") {
    return "Space";
  }
  if (key.length === 1) {
    return key.toLowerCase();
  }
  return key;
}

export function isEditableTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) {
    return false;
  }
  const tag = target.tagName;
  return (
    tag === "INPUT" ||
    tag === "TEXTAREA" ||
    tag === "SELECT" ||
    Boolean(target.isContentEditable)
  );
}

function sequenceKeyMatches(normalized: string, expected: string): boolean {
  if (expected === "Enter") {
    return normalized === "Enter" || normalized === "Space";
  }
  return normalized === expected;
}

export function advanceSequence(key: string, state: SequenceState): SequenceState {
  const normalized = normalizeKey(key);
  const expected = GAMER_ZONE_SEQUENCE[state.index];

  if (sequenceKeyMatches(normalized, expected)) {
    const nextIndex = state.index + 1;
    return {
      index: nextIndex === GAMER_ZONE_SEQUENCE.length ? 0 : nextIndex,
      unlocked: nextIndex === GAMER_ZONE_SEQUENCE.length,
    };
  }

  const restart = sequenceKeyMatches(normalized, GAMER_ZONE_SEQUENCE[0]) ? 1 : 0;
  return { index: restart, unlocked: false };
}
